import Typography from "@mui/material/Typography";
import BarChartIcon from "@mui/icons-material/BarChart";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import PieChartIcon from "@mui/icons-material/PieChart";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import TableChartIcon from "@mui/icons-material/TableChart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import React, { FunctionComponent } from "react";
import { VizType } from "../../../../../models/Reporting/ReportModel";
import AcxToggleButton from "../../../../UI/AcxToggleButton";
import { styled } from "@mui/material/styles";

const StyledTypeText = styled(Typography)(({ theme }) => ({
    fontWeight: "inherit",
    color: "inherit",
    fontSize: "inherit",
}));

interface OwnProps {
    defaultValue?: VizType;
    onChange?: (arg: VizType) => void;
}

type Props = OwnProps;

const ReportTypeToggle: FunctionComponent<Props> = (props) => {
    return (
        <AcxToggleButton
            id="viz-type"
            justifyContent={"space-between"}
            defaultValue={props.defaultValue}
            onChange={props.onChange}
            size={"large"}
            items={[
                {
                    value: VizType.Bar,
                    element: (
                        <div>
                            <EqualizerIcon fontSize={"large"} />
                            <StyledTypeText>Bar</StyledTypeText>
                        </div>
                    ),
                },
                {
                    value: VizType.Histogram,
                    sizeOverride: "default",
                    element: (
                        <div>
                            <BarChartIcon fontSize={"large"} />
                            <StyledTypeText>Histogram</StyledTypeText>
                        </div>
                    ),
                },
                {
                    value: VizType.Table,
                    element: (
                        <div>
                            <TableChartIcon fontSize={"large"} />
                            <StyledTypeText>Table</StyledTypeText>
                        </div>
                    ),
                },
                {
                    value: VizType.Pie,
                    element: (
                        <div>
                            <PieChartIcon fontSize={"large"} />
                            <StyledTypeText>Pie</StyledTypeText>
                        </div>
                    ),
                },
                {
                    value: VizType.Line,
                    element: (
                        <div>
                            <TrendingUpIcon fontSize={"large"} />
                            <StyledTypeText>Line</StyledTypeText>
                        </div>
                    ),
                },
                {
                    value: VizType.HorizontalBar,
                    sizeOverride: "default",
                    element: (
                        <div>
                            <EqualizerIcon
                                sx={{ transform: "rotate(90deg)" }}
                                fontSize={"large"}
                            />
                            <StyledTypeText>Horizontal Bar</StyledTypeText>
                        </div>
                    ),
                },
                {
                    value: VizType.Scatter,
                    element: (
                        <div>
                            <ScatterPlotIcon fontSize={"large"} />
                            <StyledTypeText>Scatter</StyledTypeText>
                        </div>
                    ),
                },
            ]}
            spacing={3}
            exclusive
        />
    );
};

export default ReportTypeToggle;
